import type { ChatStore } from "@/Modules/Chat/Store";
import type { UserStore } from "@/Modules/User/Store";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { getSubscription } from "@/Services/TherapyApi/Subscriptions";

import SubscriptionTransformer from "@/Modules/Transformers/Subscription";

import useUserStore from "@/Modules/User/Store";
import useChatStore from "@/Modules/Chat/Store";

import { hasValue } from "@/Utils/Objects";

type StoreDeps = { chatStore: ChatStore; userStore: UserStore };

async function loadChatRoomUserAH(chatRoomId: string): Promise<void> {
  const userStore = useUserStore();
  const chatStore = useChatStore();

  if (!hasValue(chatStore.rooms[chatRoomId])) return;

  chatStore.rooms[chatRoomId].user.isLoadingUser = true;

  const chatRoomUserId = chatStore.rooms[chatRoomId].user.id;
  const userId = userStore.user?.id;

  if (hasValue(userId)) {
    await loadSubscription({ chatStore, userStore })(chatRoomUserId, chatRoomId);
  }

  chatStore.rooms[chatRoomId].user.isLoadingUser = false;
}

const loadSubscription =
  (stores: StoreDeps) =>
  async (chatRoomUserId: string, chatRoomId: string): Promise<void> => {
    try {
      const subscriptionApi = await getSubscription(chatRoomUserId);
      const subscription = SubscriptionTransformer.toDomain(subscriptionApi);

      if (subscription) {
        stores.chatStore.rooms[chatRoomId]!.user.subscription = subscription;
      }
    } catch (error: unknown) {
      handleGenericError(stores);
    }
  };

const handleGenericError =
  ({ userStore }: StoreDeps) =>
  () => {
    userStore.notification = {
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
      code: "generic error",
    };
  };

export default loadChatRoomUserAH;
